import { Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { SOCIAL_ICONS } from "./Social";
import { CONTACT, SOCIALS } from "../data/site";

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="relative scroll-mt-20 border-t border-zinc-800/60 py-20 lg:py-28"
  >
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-amber-500/20 bg-gradient-to-b from-amber-500/[0.06] to-[#12141A] p-8 text-center sm:p-12">
          <div
            aria-hidden="true"
            className="absolute -top-24 left-1/2 h-48 w-96 -translate-x-1/2 rounded-full bg-amber-500/10 blur-3xl"
          />
          <div className="relative">
            <div className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full border border-amber-500/30 bg-amber-500/10">
              <Mail className="h-7 w-7 text-amber-300" aria-hidden="true" />
            </div>
            <p className="eyebrow mt-6" data-testid="contact-eyebrow">
              Contact
            </p>
            <h2
              data-testid="contact-heading"
              className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl"
            >
              {CONTACT.heading}
            </h2>
            <p className="mx-auto mt-4 max-w-xl leading-relaxed text-zinc-400">
              {CONTACT.message}
            </p>
            <div className="mt-8 flex justify-center">
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="contact-email-btn"
                className="gold-btn px-8 py-4 text-sm"
              >
                <Mail className="h-4 w-4" aria-hidden="true" />
                Email Sandstorm
              </a>
            </div>
            <p className="mt-4" data-testid="contact-email-address">
              <a
                href={`mailto:${CONTACT.email}`}
                className="font-mono text-sm text-amber-300 underline-offset-4 transition-colors hover:text-amber-200 hover:underline"
              >
                {CONTACT.email}
              </a>
            </p>
            <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.id];
                return (
                  <a
                    key={s.id}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`contact-social-${s.id}`}
                    className="ghost-btn px-6 py-3 text-sm"
                  >
                    <Icon className="h-4 w-4 text-amber-300" />
                    Message on {s.name}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
